export default class DeskpadLayers {
  constructor(canvas) {
    this.canvas = canvas;
    canvas.on({
      // "selection:cleared": this.updateZ,
      // "selection:updated": this.updateZ,
      // "selection:created": this.updateZ,
      // "object:moved": this.updateZ,
      // "object:modified": this.updateZ,
      "object:added": this.updateZ,
      "object:removed": this.handleTopObjectSelection
    });
  }

  updateOrder = objs => {
    const canvasObjs =  this.canvas.getObjects();
    for (let index = 0; index < objs.length; index += 1) {
      const obj = objs[index];
      obj.bringToFront();
    }
    const cutzoneObj = canvasObjs.find(obj => obj.id === 'cutzone');
    if (cutzoneObj) {
      cutzoneObj.moveTo(1000);
    }
    canvasObjs.forEach(obj => obj.maks && obj.sendToBack());
    this.canvas.fire("zindex:updated");
  }


  // layersReordered = layers => {
  //   const { canvas } = this;
  //   const canvasObjects = canvas.getObjects();
  //   Object.keys(layers).forEach(id => {
  //     const z = layers[id];
  //     const targetLayer = canvasObjects.find(obj => obj.id === id);
  //     if (targetLayer) {
  //       targetLayer.zIndex = z - 1;
  //     }
  //   })
  //   this.commitZ();
  // };

  // updateServiceLayers = () => {
  //   this.canvas.cutzoneObj.cutzone.bringToFront();
  // }

  // getById = id => {
  //   return this.canvas.getObjects().find(o => o.id === id);
  // }

  // updateZ = e => {
  //   const { canvas } = this;
  //   if (!canvas.loaded) return;
  //   const canvasObjects = canvas
  //     .getObjects()
  //     .filter(obj => !obj.excludeFromExport);
  //   for (let index = 0; index < canvasObjects.length; index += 1) {
  //     const obj = canvasObjects[index];
  //     const z = index;
  //     obj.zIndex = z + 1;
  //   }
  // };

  // applyZ = _ => {
  //   this.updateZ();
  //   this.commitZ();
  // };

  // commitZ = () => {
  //   const { canvas } = this;
  //   const canvasObjects = canvas.getObjects();
  //   for (let index = 0; index < canvasObjects.length; index += 1) {
  //     const obj = canvasObjects[index];
  //     obj.moveTo(obj.zIndex);
  //     if (obj.mask) {
  //       obj.moveTo(9999);
  //     }
  //   }
  //   const cutzoneObj = canvasObjects.find(obj => obj.id === 'cutzone');
  //   if (cutzoneObj) {
  //     cutzoneObj.moveTo(1000);
  //   }
  //   canvas.fire("zindex:updated");

  getTopObject = () => this.canvas.getObjects().filter(obj => !obj.excludeFromExport && obj.evented).pop();

  handleTopObjectSelection = e => {
    const obj = e.target;
    if (!obj) return;
    if (obj.type === 'group') return;
    if (obj.clipId) {
      this.canvas.discardActiveObject();
      return;
    }
    const topObject = this.getTopObject();
    if (topObject) {
      this.canvas.setActiveObject(topObject);
    }
  }

}
